module.exports = __webpack_public_path__ + "static/img/14000299.8fb8088b.png";